import { actions as formActions } from 'react-redux-form'

import * as h2Api from '../../h2Api'
import { browserHistory } from '../../Routes'

export const TOGGLE_EDIT_MODAL = 'CP_TOGGLE_EDIT_MODAL'
export const TOGGLE_STANDARD = 'CP_SELECTED_STANDARD'
export const SELECT_GRADE_SUBJECT = 'CP_SELECT_GRADE_SUBJECT'
export const COURSE_SEARCH_RESULTS = 'CP_COURSE_SEARCH_RESULTS'
export const COURSE_SCHEDULE_RESULTS = 'CP_COURSE_SCHEDULE_RESULTS'
export const TOGGLE_COLUMN_WIDTH = 'CP_TOGGLE_COLUMN_WIDTH'
export const COURSE_SELECT_FOR_VIEW = 'CP_COURSE_SELECT_FOR_VIEW'
export const CREATE_SCHEDULE = 'CP_CREATE_SCHEDULE'
export const SAVE_NOTE = 'CP_SAVE_NOTE'
export const CREATE_NOTE = 'CP_CREATE_NOTE'
export const COURSE_SET_GRADE = 'CP_COURSE_SET_GRADE'
export const COURSE_SCHEDULE_INITIAL_RESULTS = 'CP_COURSE_SCHEDULE_INITIAL_RESULTS'
export const TOGGLE_VALIDATION_DESCRIPTION = 'CP_TOGGLE_VALIDATION_DESCRIPTION'
export const TUTORIAL_ACKNOWLEDGE = 'CP_TUTORIAL_ACKNOWLEDGE'
export const LIST_SCHEDULES = 'CP_LIST_SCHEDULES'
export const REPORT_DATA_SAVE_PORTFOLIO_DISMISS = 'CP_REPORT_DATA_SAVE_PORTFOLIO_DISMISS'
export const REPORT_DATA_SAVE_PORTFOLIO = 'CP_REPORT_DATA_SAVE_PORTFOLIO'

export const listSchedules = () => dispatch => {
  return dispatch(h2Api.get(`/courses/list/schedules`)({ type: LIST_SCHEDULES }))
}

export const createNote = (selectedEntry, form) => dispatch => {
  return dispatch(
    h2Api.post(`/courses/schedule/${selectedEntry.id}/note`, form)({ type: SAVE_NOTE })
  ).then(v => {
    dispatch(formActions.reset('planning.courseplanner.noteForm'))
    dispatch({ type: CREATE_NOTE, note: v })

    return v
  })
}

export const setCoursePlanToPrimary = planId => (dispatch, getState) => {
  return dispatch(h2Api.put(`/courses/${planId}/default`)({ type: COURSE_SET_GRADE }))
}

export const createNewSchedule = standardId => dispatch => {
  return dispatch(
    h2Api.post(`/courses/schedule/new`, { standardId })({ type: CREATE_SCHEDULE })
  ).then(v => browserHistory.push(`/planning/courses/detail/${v.id}`))
}

export const toggleValidationDescription = () => dispatch => {
  return dispatch({ type: TOGGLE_VALIDATION_DESCRIPTION })
}

export const getScheduleForUser = scheduleId => dispatch => {
  return dispatch(
    h2Api.get(`/courses/schedule${scheduleId ? `/${scheduleId}` : ''}`)({
      type: COURSE_SCHEDULE_INITIAL_RESULTS
    })
  ).then(f => dispatch({ type: COURSE_SET_GRADE, usr: f.details.user }))
}

export const getPrimaryScheduleForUser = userId => dispatch => {
  return dispatch(
    h2Api.get(`/courses/schedule/primary/${userId}`)({
      type: COURSE_SCHEDULE_INITIAL_RESULTS
    })
  ).then(f => dispatch({ type: COURSE_SET_GRADE, usr: f.details.user }))
}

export const saveCoursePlan = user => dispatch => {
  return dispatch(
    h2Api.post(`/courses/schedule/primary/${user ? `${user.id}/` : ''}save`)({
      type: REPORT_DATA_SAVE_PORTFOLIO,
      user
    })
  )
}

export const closeConfirm = () => dispatch => {
  dispatch({ type: REPORT_DATA_SAVE_PORTFOLIO_DISMISS })
}

export const acknowledgeTutorial = scheduleId => dispatch => {
  return dispatch(
    h2Api.put(`/courses/schedule/${scheduleId}/acknowledgeTutorial`)({
      type: TUTORIAL_ACKNOWLEDGE
    })
  )
}

export const selectClassForView = c => dispatch => {
  return Promise.resolve(true)
}

export const toggleColumnWidth = s => dispatch => {
  dispatch({ type: TOGGLE_COLUMN_WIDTH, state: s })
}

export const selectCourse = scheduledCourse => dispatch => {
  if (scheduledCourse != null) {
    dispatch(
      formActions.change('planning.courseplanner.noteForm.courseId', scheduledCourse.id)
    )
  } else {
    dispatch(formActions.reset('planning.courseplanner.noteForm'))
  }

  return dispatch({ type: COURSE_SELECT_FOR_VIEW, scheduledCourse })
}

export const removeCourse = (scheduleId, scheduledCourseId) => dispatch => {
  return dispatch(
    h2Api.doDelete(`/courses/schedule/${scheduleId}/${scheduledCourseId}`)({
      type: COURSE_SCHEDULE_RESULTS
    })
  )
}

export const scheduleCourse = (scheduleId, gradeLevel, courseId) => dispatch => {
  return dispatch(
    h2Api.post(`/courses/schedule/${scheduleId}`, {
      courseId,
      gradeLevel
    })({ type: COURSE_SCHEDULE_RESULTS })
  )
}

export const selectClassGradeForAddition = (gradeLevel, subjectArea) => dispatch => {
  console.log(gradeLevel, subjectArea)
  dispatch({ type: SELECT_GRADE_SUBJECT, gradeLevel, subjectArea })
  dispatch({ type: TOGGLE_EDIT_MODAL, visible: true })

  return dispatch(h2Api.get('/courses/catalog')({ type: COURSE_SEARCH_RESULTS }))
}

export const toggleEditModal = visible => dispatch => {
  return dispatch({ type: TOGGLE_EDIT_MODAL, visible })
}

export const toggleSelectedStandard = standard => dispatch => {
  return dispatch({ type: TOGGLE_STANDARD, standard })
}
